import React, { useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// import idcard from "../assets/IDCARCIMAGE.png";
import idcard from "../assets/SVG/ID_Card.svg";
import { RoutesPathList } from "@/config/routes/Routes.tsx";
import bgSNS from "../assets/SVG/bgSNS.svg";
import scanSNS from "../assets/SVG/scanSNS.svg";
import { isSNS } from "@/utils/utils";

const ScanIDPOS: React.FC = () => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [image, setImage] = useState<File | null>(null);
  const navigate = useNavigate();

  const handleCapture = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setImage(file);
    }
  };

  const openCamera = () => {
    fileInputRef.current?.click();
  };

  const [selected, setSelected] = useState("Passport");

  return !isSNS() ? (
    <div className="overflow-hidden min-h-screen w-full bg-[#F3F3F3] pb-[2.6rem] flex flex-col justify-between items-center">
      <div className="flex flex-col items-center">
        <div className="mt-[3rem] mx-5">
          <div className="flex felx-row gap-3">
            <div className="border border-[#202A43] bg-[#202A43] rounded-[0.25rem] w-[6.3rem] h-[0.6875rem]"></div>
            <div className="border border-[#D9D9D9] bg-[#D9D9D9] rounded-[0.25rem] w-[6.3rem] h-[0.6875rem]"></div>
            <div className="border border-[#D9D9D9] bg-[#D9D9D9] rounded-[0.25rem] w-[6.3rem] h-[0.6875rem]"></div>
          </div>
        </div>

        <button
          className="flex mt-[2.5rem] mr-[19rem]"
          onClick={() => navigate("/pos/new-client-pos")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="26"
            viewBox="0 0 16 26"
            fill="none"
          >
            <path
              d="M13.5 2L3 14L13.5 24"
              stroke="#202A43"
              stroke-width="4"
              stroke-linecap="round"
            />
          </svg>
        </button>

        {image ? (
          <div className="mt-[3rem] flex flex-col items-center gap-4">
            <img
              src={URL.createObjectURL(image)}
              alt="captured"
              className="w-[80%] h-auto rounded"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="67"
              height="52"
              viewBox="0 0 67 52"
              fill="none"
            >
              <g clip-path="url(#clip0_3027_6849)">
                <path
                  d="M67.0003 6.61224V8.53501L66.1763 10.3549L65.4824 11.2632C51.9221 24.6744 38.6252 38.3878 24.9155 51.6285C24.0481 52.1221 22.4579 52.1221 21.5905 51.6285C14.5389 44.9294 7.65108 37.9794 0.904662 30.9684C-0.208497 29.2804 -0.309693 27.2434 0.686207 25.4718C1.31909 24.3464 4.47705 21.3015 5.67213 20.8433C7.32019 20.2099 9.24774 20.4993 10.6757 21.5153L23.0891 33.9458L23.3188 34.0149L56.5273 0.864832C58.1754 -0.193013 60.2651 -0.300727 61.9823 0.651012C63.0408 1.23781 66.0767 4.28916 66.5489 5.37916C66.7272 5.79072 66.7578 6.26338 66.9987 6.61224H67.0003Z"
                  fill="#202A43"
                />
              </g>
              <defs>
                <clipPath id="clip0_3027_6849">
                  <rect width="67" height="52" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        ) : (
          <div className="flex flex-col items-center">
            <div className="space-y-4 mt-[2rem]">
              {["Passport", "National ID"].map((option) => (
                <label
                  key={option}
                  className={`flex items-center justify-between px-8 border rounded-[0.625rem] w-[20.125rem] h-[4.1875rem] cursor-pointer transition
        ${selected === option ? "border-[#222B45]" : "border-[#D9D9D9]"}`}
                >
                  <input
                    type="radio"
                    name="document"
                    value={option}
                    checked={selected === option}
                    onChange={() => setSelected(option)}
                    className="hidden"
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="33"
                    viewBox="0 0 32 33"
                    fill="none"
                  >
                    <circle
                      cx="16"
                      cy="16.5"
                      r="15.5"
                      stroke="#222B45"
                      strokeOpacity="0.53"
                    />
                    {selected === option && (
                      <circle cx="16" cy="16.5" r="11" fill="#222B45" />
                    )}
                  </svg>
                  <div className="text-[#222B45] text-[1.2rem] font-[500] font-[satoshi]">
                    {option}
                  </div>
                </label>
              ))}
            </div>
            <img className="mt-[3rem] items-center justify-center" src={idcard} alt="foto" />
          </div>
        )}
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleCapture}
        style={{ display: "none" }}
      />
      <div className="flex flex-col gap-2 mt-[6rem] items-center ">
        {image ? (
          <div
            className="font-[satoshi] text-[#202A43] underline font-[500] text-[1.1875rem]"
            onClick={openCamera}
          >
            Retake Photo
          </div>
        ) : (
          <button
            onClick={openCamera}
            type="button"
            className="button--blue !w-[10.3125rem] !h-[3.3125rem] !text-[1rem] gap-6"
          >
            Open Camera
          </button>
        )}
        {image ? (
          <NavLink to={RoutesPathList.FormPOS}>
            <button
              type="submit"
              className="button--blue !w-[10.3125rem] !h-[3.3125rem] "
            >
              Done
            </button>
          </NavLink>
        ) : (
          <NavLink to={RoutesPathList.FormPOS}>
            <button
              type="submit"
              className="!w-[18.4375rem] !h-[3.5625rem] rounded-[0.8125rem] text-[#202A43] text-[1rem] font-[500]"
            >
              Manual input
            </button>
          </NavLink>
        )}
      </div>
    </div>
  ) : (
    <div
      className="overflow-hidden min-h-screen w-full bg-[#1C1C1C] pb-[2.6rem] flex flex-col justify-between items-center"
      style={{
        backgroundImage: `url(${bgSNS})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div className="flex flex-col justify-start items-start">
        <div className="mt-[3rem] mx-5">
          <div className="flex flex-row gap-3">
            <div className="border border-[#8AFEFD] bg-[#8AFEFD] rounded-[0.25rem] w-[6.3rem] h-[0.6875rem]"></div>
            <div className="border border-[#303030] bg-[#303030] rounded-[0.25rem] w-[6.3rem] h-[0.6875rem]"></div>
            <div className="border border-[#303030] bg-[#303030] rounded-[0.25rem] w-[6.3rem] h-[0.6875rem]"></div>
          </div>
        </div>

        <button
          className="flex mt-[2.5rem] ml-[1.3rem]"
          onClick={() => navigate("/pos/new-client-pos-sns")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="26"
            viewBox="0 0 16 26"
            fill="none"
          >
            <path
              d="M13.5 2L3 14L13.5 24"
              stroke="#8AFEFD"
              stroke-width="4"
              stroke-linecap="round"
            />
          </svg>
        </button>

        {image ? (
          <div className="mt-[3rem] flex flex-col items-center gap-4">
            <img
              src={URL.createObjectURL(image)}
              alt="captured"
              className="w-[80%] h-auto rounded"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="139"
              height="124"
              viewBox="0 0 139 124"
              fill="none"
            >
              <g filter="url(#filter0_f_4446_47305)">
                <path
                  d="M103 42.6127V44.5355L102.176 46.3554L101.482 47.2637C87.9221 60.6749 74.6252 74.3883 60.9155 87.629C60.0481 88.1226 58.4579 88.1226 57.5905 87.629C50.5389 80.9299 43.6511 73.9799 36.9047 66.9689C35.7915 65.2808 35.6903 63.2439 36.6862 61.4723C37.3191 60.3469 40.4771 57.302 41.6721 56.8438C43.3202 56.2104 45.2477 56.4998 46.6757 57.5158L59.0891 69.9463L59.3188 70.0154L92.5273 36.8653C94.1754 35.8075 96.2651 35.6998 97.9823 36.6515C99.0408 37.2383 102.077 40.2897 102.549 41.3796C102.727 41.7912 102.758 42.2639 102.999 42.6127H103Z"
                  fill="#8AFEFD"
                />
              </g>
              <g filter="url(#filter1_f_4446_47305)">
                <path
                  d="M103 42.6127V44.5355L102.176 46.3554L101.482 47.2637C87.9221 60.6749 74.6252 74.3883 60.9155 87.629C60.0481 88.1226 58.4579 88.1226 57.5905 87.629C50.5389 80.9299 43.6511 73.9799 36.9047 66.9689C35.7915 65.2808 35.6903 63.2439 36.6862 61.4723C37.3191 60.3469 40.4771 57.302 41.6721 56.8438C43.3202 56.2104 45.2477 56.4998 46.6757 57.5158L59.0891 69.9463L59.3188 70.0154L92.5273 36.8653C94.1754 35.8075 96.2651 35.6998 97.9823 36.6515C99.0408 37.2383 102.077 40.2897 102.549 41.3796C102.727 41.7912 102.758 42.2639 102.999 42.6127H103Z"
                  fill="#8AFEFD"
                />
              </g>
              <path
                d="M103 42.6127V44.5355L102.176 46.3554L101.482 47.2637C87.9221 60.6749 74.6252 74.3883 60.9155 87.629C60.0481 88.1226 58.4579 88.1226 57.5905 87.629C50.5389 80.9299 43.6511 73.9799 36.9047 66.9689C35.7915 65.2808 35.6903 63.2439 36.6862 61.4723C37.3191 60.3469 40.4771 57.302 41.6721 56.8438C43.3202 56.2104 45.2477 56.4998 46.6757 57.5158L59.0891 69.9463L59.3188 70.0154L92.5273 36.8653C94.1754 35.8075 96.2651 35.6998 97.9823 36.6515C99.0408 37.2383 102.077 40.2897 102.549 41.3796C102.727 41.7912 102.758 42.2639 102.999 42.6127H103Z"
                fill="#8AFEFD"
              />
              <defs>
                <filter
                  id="filter0_f_4446_47305"
                  x="0.900002"
                  y="0.900002"
                  width="137.2"
                  height="122.199"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation="17.55"
                    result="effect1_foregroundBlur_4446_47305"
                  />
                </filter>
                <filter
                  id="filter1_f_4446_47305"
                  x="25.1"
                  y="25.1"
                  width="88.8"
                  height="73.799"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation="5.45"
                    result="effect1_foregroundBlur_4446_47305"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        ) : (
          <div className="flex flex-col items-center">
            <div className="space-y-4 mt-[2rem]">
              {["Passport", "National ID"].map((option) => (
                <label
                  key={option}
                  className={`flex items-center justify-between ml-[1.5rem] px-8 border rounded-[0.625rem] bg-[#272727] w-[20.125rem] h-[4.1875rem] cursor-pointer transition
        ${selected === option ? "border-[#8AFEFD]" : "border-[#3F3F3F]"}`}
                >
                  <input
                    type="radio"
                    name="document"
                    value={option}
                    checked={selected === option}
                    onChange={() => setSelected(option)}
                    className="hidden"
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="33"
                    viewBox="0 0 32 33"
                    fill="none"
                  >
                    <circle
                      cx="16"
                      cy="16.5"
                      r="15.5"
                      stroke="#8E8E8E87"
                      strokeOpacity="0.53"
                    />
                    {selected === option && (
                      <circle cx="16" cy="16.5" r="11" fill="#8AFEFD" />
                    )}
                  </svg>
                  <div className="text-[#fff] text-[1.2rem] font-[400] font-[helvetica]">
                    {option}
                  </div>
                </label>
              ))}
            </div>
            <img
              className="mt-[3rem] items-center justify-center ml-[1.5rem]"
              src={scanSNS}
              alt="foto"
            />
          </div>
        )}
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleCapture}
        style={{ display: "none" }}
      />
      <div className="flex flex-col gap-2 mt-[6rem] items-center ">
        {image ? (
          <div
            className="font-[helvetica] text-[#8AFEFD] underline font-[400] text-[1.1875rem]"
            onClick={openCamera}
          >
            Retake Photo
          </div>
        ) : (
          <button
            onClick={openCamera}
            type="button"
            className="flex items-center gap-6 justify-center border border-[#8AFEFD] !w-[18.4375rem] !h-[3.5625rem] rounded-[0.8125rem] text-white font-[helvetica] text-[1rem] font-[500]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="33"
              height="23"
              viewBox="0 0 33 23"
              fill="none"
            >
              <path
                d="M31.6838 22.2C31.2178 22.6549 30.5645 22.9237 29.9079 22.9995H2.558C1.22342 22.891 0.154584 21.873 0 20.574V7.41964C0.186605 6.02798 1.42364 4.97265 2.87048 5.02979C2.91354 4.85659 2.91759 4.70676 3.02469 4.55153C3.13768 4.38732 3.38539 4.19544 3.59076 4.16993C3.73799 4.1516 3.97612 4.20047 4.10089 4.1649C4.18959 4.13975 4.30627 3.90978 4.51054 3.88211C4.9154 3.82714 5.44724 3.91804 5.86646 3.88786C6.03944 3.92487 6.17599 4.14873 6.24592 4.1667C6.2566 4.16957 6.41523 4.16849 6.4594 4.17065C6.65962 4.17999 6.78954 4.14406 6.98425 4.23353C7.27685 4.36792 7.49548 4.7161 7.47303 5.03194L8.72221 5.02979C8.74245 4.94858 8.78589 4.8645 8.82784 4.79156C9.25994 4.03626 9.67437 3.26803 10.0936 2.50591C10.709 1.38698 11.1322 0.158461 12.6428 0H19.8232C20.5519 0.0977355 21.1802 0.488678 21.5873 1.08048C22.2792 2.27487 22.8762 3.52459 23.563 4.72113C23.5958 4.77826 23.7341 5.02008 23.7636 5.02835L29.9447 5.03051C31.1729 5.16022 32.1682 6.02726 32.4269 7.20656C32.5152 11.6521 32.4376 16.1199 32.4659 20.574C32.4199 21.1137 32.0714 21.8216 31.6838 22.2ZM24.0628 13.006C24.0628 8.75919 20.5365 5.31653 16.1864 5.31653C11.8363 5.31653 8.30999 8.75919 8.30999 13.006C8.30999 17.2528 11.8363 20.6955 16.1864 20.6955C20.5365 20.6955 24.0628 17.2528 24.0628 13.006ZM30.7515 8.05887C30.7515 7.33232 30.1483 6.74375 29.4044 6.74375C28.6606 6.74375 28.0573 7.33268 28.0573 8.05887C28.0573 8.78506 28.6606 9.37399 29.4044 9.37399C30.1483 9.37399 30.7515 8.78506 30.7515 8.05887Z"
                fill="white"
              />
              <path
                d="M16.1843 18.3862C19.2287 18.3862 21.6967 15.9768 21.6967 13.0046C21.6967 10.0325 19.2287 7.62305 16.1843 7.62305C13.1399 7.62305 10.6719 10.0325 10.6719 13.0046C10.6719 15.9768 13.1399 18.3862 16.1843 18.3862Z"
                fill="white"
              />
            </svg>
            <p className="pt-[0.4rem]">Open Camera</p>
          </button>
        )}
        {image ? (
          <NavLink to={RoutesPathList.FormSNS}>
            <button
              type="submit"
              className="button__green w-[19.4375rem] !h-[3.5625rem] mt-[1.5rem] !text-[black] font-[helvetica] font-[600]"
            >
              Done
            </button>
          </NavLink>
        ) : (
          <NavLink to={RoutesPathList.FormSNS}>
            <button
              type="submit"
              className="!w-[18.4375rem] !h-[3.5625rem] rounded-[0.8125rem] text-[#8AFEFD] font-[helvetica] text-[1rem] font-[500]"
            >
              Manual input
            </button>
          </NavLink>
        )}
      </div>
    </div>
  );
};

export default ScanIDPOS;
